// extracted by mini-css-extract-plugin
module.exports = {"container":"Benefits_container__w_hmM","card":"Benefits_card__fOjMf","text":"Benefits_text__OEM5E","title":"Benefits_title__udp2k"};